'use client';

import { useEffect, useRef } from 'react';
import Script from 'next/script';

import Caption from '../Caption/Caption';

import { TwitterEmbedPropTypes } from './TwitterEmbed.types';

export default function TwitterEmbed({ data, className = '' }: TwitterEmbedPropTypes) {
  const ref = useRef<HTMLQuoteElement>(null);

  // (re)process whenever url changes
  useEffect(() => {
    if (typeof window !== 'undefined' && window.instgrm) {
      window.instgrm.Embeds.process();
    }
  }, [data?.embedUrl]);

  return (
    <>
      <Script
        async
        src='https://platform.twitter.com/widgets.js'
        onLoad={() => {
          if (window.twttr && ref.current) {
            window.twttr.widgets.load(ref.current);
          }
        }}
      />

      <figure>
        <blockquote
          ref={ref}
          className={`twitter-tweet mx-auto inline w-full! max-w-[500px]! min-w-[calc(100vw-48px)]! sm:min-w-[50rem]! ${className}`}
          data-width='500'
          data-dnt='true'
          data-align='center'
        >
          <a href={data?.embedUrl} />
        </blockquote>

        {data?.bodyCopy && <Caption bodyCopy={data?.bodyCopy} />}
      </figure>
    </>
  );
}
